import React from 'react';
function Success() {
	return (
		<div>
			<h1>Thank you!</h1>
			<p>This is a custom thank you page for form submissions</p>
		</div>
	);
}

export default Success;
